// The purpose of this custom hook is to keep the previous value in case we need to compare past value with current value.

import React, { useEffect, useRef } from 'react';

export default function usePreviousValue(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
